

export const CREATE_POSTAL_NUMBER_REQUEST = 'CREATE_POSTAL_NUMBER_REQUEST';
export const CREATE_POSTAL_NUMBER_SUCCESS = 'CREATE_POSTAL_NUMBER_SUCCESS';
export const CREATE_POSTAL_NUMBER_FAILURE = 'CREATE_POSTAL_NUMBER_FAILURE';

export const FETCH_PRICE_REQUEST = 'FETCH_PRICE_REQUEST';
export const FETCH_PRICE_SUCCESS = 'FETCH_PRICE_SUCCESS';
export const FETCH_PRICE_FAILURE = 'FETCH_PRICE_FAILURE';

export const UPDATE_PRICE_REQUEST = 'UPDATE_PRICE_REQUEST';
export const UPDATE_PRICE_SUCCESS = 'UPDATE_PRICE_SUCCESS';
export const UPDATE_PRICE_FAILURE = 'UPDATE_PRICE_FAILURE'; 